import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { AuthorizationService } from '../../../auth.service';
import { User } from '../../../classes/user';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})

export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  User: User;
  signedin: boolean;

  userMenu = [{ title: 'Log out' }];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private authService: AuthorizationService) {
    this.authService.currentUser.subscribe(
      res => {
        this.User = res;
        this.signedin = (this.User && this.User.Token) ? true : false;
      });
  }

  ngOnInit() {
    this.menuService.onItemClick().subscribe((event) => {
      this.onItemSelection(event.item.title);
    });
  }

  onItemSelection(title): void {
    if (title === 'Log out') {
      this.authService.SignOut(false);
    }
  }

  SSOSignIn() {
    this.authService.SignIn();
  }

  NotSignedIn(): boolean {
    return !this.signedin;
  }

  SignedIn() {
    return this.signedin;
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }
}



// WEBPACK FOOTER //
// ./src/app/@theme/components/header/header.component.ts